import * as yup from "yup";


export interface IEmploymentType {
    id?: number,
    selection_Term: string,
}

export const emptyEmploymentType: IEmploymentType = {
    selection_Term: "",
}

export const schema = yup.object().shape({
    selection_Term: yup.string().required("Selection term is required")
})